import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import { Box, Typography, makeStyles } from '@material-ui/core';

import Page from 'layout/Page';
import Container from 'components/Container';
import LoadingSpinner from 'components/LoadingSpinner';
import TabPanel from 'components/TabPanel';
import useApi, { GLOBAL_SEARCH } from 'hooks/useApi';
import { groupBy } from 'utils/array-helpers';
import SearchTabs from './components/SearchTabs';
import DashboardsList from '../DashboardsList/DashboardsList';

const useStyles = makeStyles({
  noResults: {
    fontSize: '1.15rem',
    fontStyle: 'italic'
  }
});

const PAGE_SIZE = 20;

const SearchResults = () => {
  const location = useLocation();
  const { state: locationState } = location;
  const term = locationState?.term;
  const classes = useStyles();

  const [state, sendRequest] = useApi();
  const [selectedTab, setSelectedTab] = useState(0);
  const [items, setItems] = useState();
  const [itemsToDisplay, setItemsToDisplay] = useState(PAGE_SIZE);
  const { data, isLoading } = state;

  useEffect(() => {
    sendRequest(GLOBAL_SEARCH({ term }));
  }, [term]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (data) {
      setItems(data);
    }
  }, [data]);

  const handleTabChange = (_, index) => {
    setSelectedTab(index);
  };

  const handleDisplayMoreHoldings = () => {
    if (data && data.length && itemsToDisplay < data.length) {
      const remainingItemsInterval =
        data.length - itemsToDisplay >= PAGE_SIZE ? PAGE_SIZE : data.length - itemsToDisplay;

      setItemsToDisplay(prevState => prevState + remainingItemsInterval);
    }
  };
  const scrollRef = useBottomScrollListener(handleDisplayMoreHoldings, PAGE_SIZE, 0);

  const getPageTitle = () => {
    return term ? `Search Results for "${term}"` : 'Search Results';
  };

  const renderLoadedContent = () => {
    const groupedItems = groupBy(items, 'objectTypeId');
    const groupKeys = Object.keys(groupedItems);

    return (
      <>
        <SearchTabs keys={groupKeys} selectedTab={selectedTab} onTabChange={handleTabChange} />
        {groupKeys.map((key, index) => (
          <TabPanel value={selectedTab} index={index}>
            <DashboardsList linkUrlPrefix="canned" items={groupedItems[key]} />
          </TabPanel>
        ))}
      </>
    );
  };

  const renderContent = () => {
    if (isLoading) {
      return <LoadingSpinner />;
    }

    if (!items || !items.length) {
      const noResultsMessage = term ? `No search results found for "${term}"` : 'No search results';
      return (
        <Box>
          <Typography className={classes.noResults}>{noResultsMessage}</Typography>
        </Box>
      );
    }

    return renderLoadedContent();
  };

  return (
    <Page title={getPageTitle()}>
      <Container ref={scrollRef} size={100} center={false} maxWidth="xl">
        {renderContent()}
      </Container>
    </Page>
  );
};

export default SearchResults;
